import { getSessionDuration } from 'application/session_duration'

export function addAlertViewEvent(data) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: "alert_view",
    session_duration: getSessionDuration(),
    alert_name: data.alert_name,
    alert_id: data.alert_id,
    event_detail: data.event_detail
  });
}

